<template>
  <div class="box-get-lastest-products w-200">
    <button type="button" class="btn btn-primary pd-l-35 pd-r-35 bd-rds-5 w-165" @click.prevent="getLatestProducts()">最新情報取得</button>
    <div v-if="reportCreationDate" class="product-bubble-wrapper">
      <div v-show="showBubble" class="product-bubble get-lastest-bubble" @mouseover="handleMouseOver()" @mouseleave="handleMouseLeave()">
        <div><strong>{{ reportCreationDate }}</strong> 時点の情報を表示しています。</div>
        <div>注）最新情報を取得した場合でも最大で2時間前のデータを取得することがあります。</div>
      </div>
      <i class="fa fa-info-circle get-lastest-bubble-icon" @mouseover="handleMouseOver()" @mouseleave="handleMouseLeave()" />
    </div>
  </div>
</template>

<script>
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    getFrom: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showBubble: false
    }
  },
  methods: {
    getLatestProducts () {
      if (this.getFrom && ['list', 'add-by-amazon'].includes(this.getFrom)) {
        let logParamsName = eventCode.manage_products.list_tab.click_get_latest_products_button
        if (this.getFrom === 'add-by-amazon') {
          logParamsName = eventCode.manage_products.add_by_amazon_tab.click_get_latest_products_button
        }
        let logParams = {
          name: logParamsName,
          properties: {}
        }
        EventService.postTrackLog(logParams)
      }

      this.$emit('handleGetLatestProducts')
    },
    handleMouseOver () {
      this.showBubble = true
    },
    handleMouseLeave () {
      this.showBubble = false
    }
  },
  computed: {
    reportCreationDate () {
      return this.$store.getters.getUser.reportCreationDate
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/GetLatestProductsButton.vue